import React, {forwardRef, KeyboardEvent, RefObject, useCallback, useEffect, useImperativeHandle, useRef} from 'react'

import EntitySelectorPane from "../../content/pane"
import {useEntitySelectorContext} from "../../context"
import {MentionOption} from "../../../editor/plugins/mentions/option"
import ProjectFinderMain from "./project-selector-main"
import {EntityType} from "../../../../gd/const/item"

type Props = {
    search              : string
}

const debug = false
// const debug = "EntitySelectorProjectsList"

// The tree below is the same one "Move to" renders and knows nothing about this
// selector, so the context stops here and it keeps its props.
const EntitySelectorProjectsList = forwardRef((props:Props, ref) => {
    const context = useEntitySelectorContext()

    debug && console.log(debug, 'render', props)

    const projectFinderRef:RefObject<any> = useRef()

    const searchString = props.search?.toLowerCase()

    useEffect(() => {
        projectFinderRef.current?.onSearchChange(searchString)
    }, [searchString])

    const onKeyDown = useCallback((event:KeyboardEvent) => {
        projectFinderRef.current.onKeyDown(event)
    }, [])

    // The component instance will be extended
    // with whatever you return from the callback passed
    // as the second argument
    useImperativeHandle(ref, () => ({
        onKeyDown,
    }))

    const onClickProject = useCallback((project: any)=>{
        const option = new MentionOption({
            id  : project.id,
            name: project.name,
            type: EntityType.PROJECT,
            data: project
        })

        debug && console.log(debug, 'onClickProject', option, project)

        context.onEntitySelected(option)
    }, [context])

    return (
        <EntitySelectorPane className="entity-selector-list">
            <ProjectFinderMain
                ref             = {projectFinderRef}
                parentProjectId = {context.projectId}
                onClickProject  = {onClickProject}
                onTab           = {context.onTab}
            />
        </EntitySelectorPane>
    )
})

export default EntitySelectorProjectsList
